<template>
  <div class=""  :data-step="generateRandomString">
    <slot></slot>
  </div>
</template>


<script>

export default {
  name: "StepManagerStep1",
  computed:{
    generateRandomString(){
      return (
          Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15)
      );
    }
  }

}
</script>


<style scoped>

</style>